import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'priceformat'
})
export class PriceformatPipe implements PipeTransform {
  transform(val,valType) {
    let data=val ? val.toString() : '';
    let str;
    let beforeDecimal;
    let afterDecimal;
    if(data.includes('.')){
      str=data.split('.');
      beforeDecimal=str[0];
      afterDecimal=str[1];
    }else{
      beforeDecimal=data;
      afterDecimal='00';
    }
    if(afterDecimal.length === 1){
      afterDecimal=afterDecimal+'0';
    }
    beforeDecimal = beforeDecimal ? beforeDecimal : 0;
    if(valType === 'integer'){
      return beforeDecimal;
    }else if(valType === 'decimal'){
      return afterDecimal;
    }
  }
}